import JsonLd from "./JsonLd";
import { SITE } from "@/config/business";

// WebSite-level schema — separate from Organization (the "who"), this is
// the "what": the site itself as an entity, with a SearchAction pointing at
// the real /courses listing's search behavior isn't a dedicated query-string
// search page today, so no SearchAction is declared here rather than
// inventing one that doesn't exist.
export default function WebSiteSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE.name,
    url: SITE.url,
    inLanguage: "en-IN",
  };

  return <JsonLd data={schema} />;
}
